import { createTheme, darken } from "@mui/material/styles";

// The page body fill in the v2 School layout.
const LAYOUT_BODY_BG = "#FFFFFF";

export const themeOptions = {
  typography: {
    fontFamily: "halcom, sans-serif",
  },
  palette: {
    primary: {
      main: "#0395D3", // Blue
      dark: "#0277A3",
    },
    secondary: {
      main: "#A836D0", // Purple
    },
    gray: {
      main: "#666666",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: "0px 4px 17.6px 0px #00000013",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        textColorPrimary: {
          "&.Mui-selected": {
            color: "inherit",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#A836D0",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        // Right-anchored drawers sit flush against the screen edge: square
        // the right corners on desktop so the paper doesn't show a rounded
        // gap. Mobile drawers are full-width and keep the default.
        paper: ({ theme, ownerState }) => ({
          ...(ownerState.anchor === "right" && {
            [theme.breakpoints.up("md")]: {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            },
          }),
        }),
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }) => ({
          borderRadius: 20,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(2px)",
          WebkitBackdropFilter: "blur(2px)",
          // On mobile every dialog fills the screen (full-screen sheet): no
          // margin, no max constraints, square corners. Mirrors MUI's
          // `fullScreen` prop so we don't have to set it per-dialog.
          [theme.breakpoints.down("sm")]: {
            margin: 0,
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "none",
            borderRadius: 0,
          },
        }),
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          // Keep scrolling inside the dialog: once the content reaches its
          // edge the gesture stops here instead of chaining to the page behind.
          overscrollBehavior: "contain",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 10,
        },
      },
    },
  },
  custom: {
    // Shared layout surfaces. The chrome (navbar + fixed sidebar) is the body
    // gray a step darker, so the two read as one chromatic family instead of
    // two unrelated grays: same hue, the chrome just recessed ~5%.
    layoutBg: {
      body: LAYOUT_BODY_BG,
      chrome: darken(LAYOUT_BODY_BG, 0.05),
    },
    glassBox: {
      borderRadius: 4,
      background: "linear-gradient(to bottom, #F3F3F3, #FFFFFF)",
      boxShadow: "0px 4px 17.6px 0px #00000013",
      border: "1px solid #FFFFFFE6",
    },
  },
};

export default createTheme(themeOptions);
